/* eslint-disable quotes */
/* eslint-disable max-len */
import PageTitle from './PageTitle';
import FantasySports from './FantasySports';
export default {
  ...PageTitle,
  ...FantasySports,
  AddCash: 'Add Cash',
  PayViaOtherMethods: 'Other Methods',
  TransactionHistory: 'Transaction History',
  CashfreePayment: 'Cashfree Payment',
  HavePromoCode: 'Have any Promo code:',
  PromoCode: 'Promo Code',
  Verify: 'Verify',
  PayUsing: 'Pay Using',
  CurrentBalance: 'Current Balance',
  AvailableBalance: 'Available Balance',
  PasswordResetLabel:
    "Don't worry just fill in your email address and we'll help you reset your password",
  ForgotYourPassword: 'Forgot Your Password',
  EmailAddress: 'Email Address',
  AlreadyAccount: 'Already have an account?',
  SignIn: 'Login',
  Submit: 'Submit',
  Password: 'Password',
  NewPassword: 'New password',
  CurrentPassword: 'Current password',
  ForgotPassword: 'Forgot Password?',
  DontHaveAccount: "Don't have an account?",
  SignUp: 'Sign up',
  OTPNotReceived: "Didn't receive the OTP",
  ResendOTP: 'Resend OTP',
  EnterOTPEmail: 'Enter OTP',
  EnterValidOTP: 'Enter Valid OTP',
  ConfirmPassword: 'Confirm Password',
  SelectDOB: 'Select Date of Birth',
  ReferralCode: 'Referral Code (Optional)',
  EnterMobile: 'Mobile Number',
  SignUpWithPhone: 'Sign up with phone',
  Continue: 'Continue',
  ConfirmPrediction: 'Confirm Prediction',
  UsableAmount: 'Usable Amount',
  UsableBonusAmount: 'Usable Bonus Amount',
  JoiningAmount: 'Joining Amount',
  AcceptAndConfirm:
    'By Joining this contest, you accept fantasy cricket’s T&C and confirm that you are not a resident of Andhra Pradesh, Assam, Odisha, Telangana, Nagaland, Meghalaya & Sikkim.',
  JoinPrediction: 'Join Prediction',
  Confirmation: 'Confirmation',
  Winnings: 'Winnings',
  Entry: 'Entry',
  Join: 'Join',
  Left: 'left',
  SpotLeft: 'Spot left',
  Teams: 'Teams',
  Winners: 'Winners',
  Points: 'Points',
  Accuracy: 'Accuracy',
  Rank: 'Rank',
  Answer: 'Answer',
  Skip: 'Skip',
  SaveYourPicks: 'Save Your Picks',
  MakeYourPicks: 'Make Your Picks',
  Result: 'Result',
  ContestType: 'Contest Type',
  HeadToHead: 'Head to Head',
  Questions: 'Questions',
  Wrong: 'Wrong',
  Correct: 'Correct',
  WinningBreakup: 'Winning Breakup',
  DeductionOver10000:
    'The actual prize money may be different than the prize money mentioned above if there is a tie for any of the winning positions. Check FAQs for further details.',
  DeductionOver10000WithDynamicContest:
    'The actual prize money may be different than the prize money mentioned above, in case the contest is not filled fully. Please wait for the contest to go live for confirmed prizes. Check FAQs for further details.',
  EmailUs: 'Email Us',
  CallUs: 'Call Us',
  ConnectWithUs: 'Connect with us',
  TeamName: 'Team Name',
  UserName: 'User Name',
  Referrals: 'Referrals',
  Earned: 'Earned',
  PAY_INFO: 'PAY INFO',
  MyWallet: 'My Wallet',
  VerifyAccount: 'Verify Account',
  Profile: 'Profile',
  ChangePassword: 'Change Password',
  HowToPlay: 'How to Play',
  ContactUs: 'Contact Us',
  CheckForUpdate: 'Check For Update',
  ReferList: 'Refer List',
  LeaderBoard: 'Leader Board',
  TermsConditions: 'Terms & Conditions',
  AboutUs: 'About Us',
  ReferFriends: 'Refer Friends',
  Logout: 'Logout',
  PERSONAL_INFO: 'PERSONAL INFO',
  POINTS_SYSTEM: 'POINTS SYSTEM',
  More: 'More',
  TotalRefers: 'Total Refers',
  YourName: 'Your Name',
  PhoneNumber: 'Phone Number',
  Gender: 'Gender',
  Male: 'Male',
  Female: ' Female',
  DateOfBirth: 'Date of Birth',
  DateOfBirthWeb: 'Date of Birth (YYYY-MM-DD)',
  State: 'State',
  UpdateProfile: 'Update Profile',
  ShareLink: 'Share Link',
  GenerateLink: 'Generate Referral Link',
  ReferGain:
    'Invite a friend and get upto ₹100 when your friend joins a game and earn 20% commission.',
  ReferRestrictionMessage: 'This feature is not available for affiliate user',
  MobileEmail: 'Mobile & Email',
  BankAccountVerification: 'Bank Account Verification',
  UploadBankPhoto: 'Upload Bank Passbook/Check Photo',
  AccountHolderName: 'Account Holder Name',
  AccountNumber: 'Account Number',
  ConfirmAccountNumber: 'Confirm Account Number',
  MissingAccountNumber: 'Enter Account Number',
  MissingConfirmAccountNumber: 'Enter Confirm Account Number',
  AccountNumberShouldMatch: 'Account Number is not matched',
  AccountShouldMatch: 'Account number entered should match with Account number on image uploaded',
  IFSC_Code: 'IFSC Code',
  MissingIFSCCode: 'Enter IFSC Code',
  InvalidIFSCCode: 'Invalid IFSC Code',
  BankName: 'Bank Name',
  MissingBankName: 'Enter Bank Name',
  SubmitForVerification: 'Submit for Verification',
  NameOnPANCard: 'Name on PAN Card',
  PAN_CardNumber: 'PAN Card Number',
  VerifyYourEmail: 'Verify your Email',
  VerifyYourAccount: 'Verify your Account',
  VerifyYourBankDetails: 'Verify Your Bank Details',
  EmailId: 'Email',
  OTP_sent: 'We will send you a 6 digit OTP for verification',
  MobileOTPSentMsg: 'OTP sent successfully to your mobile number',
  EmailOTPSentMsg: 'OTP sent successfully to your email',
  OTPVerifiedSuccess: 'OTP verified successfully',
  SendOTP: 'Send OTP',
  VerifyYourMobile: 'Verify your Mobile',
  VerifyToCompleteBelowSteps:
    'To verify your mobile number please complete the steps mentioned below:',
  VerifyYourPANDetails: 'Verify your PAN Details',
  AddYourPANDetails: 'Add your PAN Details',
  AddYourBankAccountDetails: 'Add your Bank Account Details',
  UploadPANCardImage: 'Upload PAN Card Image',
  UploadBankPassbookImage: 'Upload Bank Passbook Image',
  AccountShouldMatchPAN: 'PAN card number entered should match with PAN number on image uploaded',
  AccountShouldMatchNameOnPAN:
    'Your profile name, name on PAN card & name on Bank account should be same',
  Atleast18: 'you should be at least 18 years',
  MyContest: 'My Contest',
  PLAY: 'PLAY',
  NOW: 'NOW',
  Edit: 'Edit',
  PredictionsUpto: 'You can create up to 6 Predictions for a single contest',
  TotalSixes: 'Total number of 6s to be hit in the 1st Innings?',
  FantasyCricket: 'Fantasy Cricket',
  FantasyKabadi: 'Fantasy Kabaddi',
  CricPredict: 'Cric Predict',
  EntryFee: 'Entry Fee',
  ChooseFromVariety: 'Choose from a variety of contests',
  AllContest: 'All Contest',
  Clone: 'Clone',
  Preview: 'Preview',
  TeamIncomplete: 'Team is incomplete. Please edit to complete.',
  FirstName: 'First Name',
  LastName: 'Last Name',
  MissingEmail: 'Enter Email',
  MissingName: 'Enter Name',
  MissingTeamName: 'Enter Team Name',
  MissingFirstName: 'Enter First Name',
  MissingLastName: 'Enter Last Name',
  InvalidEmailId: 'Invalid Email Address',
  MissingPassword: 'Enter Password',
  ResetPassword: 'Reset Password',
  ResetPasswordMsg: 'Password reset successfully',
  SignInSocial: 'Sign in with Social',
  SignUpSocial: 'Sign up with Social',
  MissingPhoneNumber: 'Enter Mobile number',
  MissingPANNumber: 'Enter PAN number',
  MissingPAN_Image: 'Select PAN Card image',
  ImageSizeMessage: 'Image size must be less than 2 mb',
  MissingBank_Image: 'Select Image',
  InvalidPhoneNumber: 'Invalid mobile number',
  PasswordsMustBeSame: 'New password and confirm password must be same',
  MissingDOB: 'Select Date of Birth',
  InValidDate: 'Invalid Date',
  userMustBe18Plus: 'user must be 18 plus ',
  TnCMustBeAccepted: 'Terms & Conditions must be accepted for register',
  WrongOTP: 'wrong OTP',
  ResidencyMustBeAccepted:
    'You will have to confirm that you are not a resident of Assam, Odisha, Nagaland, Meghalaya and Telangana',
  PleaseEnterScreenName: 'Please enter a profile/screen name',
  ErrorSignOut: 'Something went wrong during sign out. Please try again later',
  JoinedContest: 'Joined Contest',
  MyTeams: 'My Teams',
  Players: 'Players',
  SaveTeam: 'Save Team',
  GetDouble: '(C) Gets 2x Points & (VC) Gets 1.5x Points',
  Confirmed: 'Confirmed',
  JoinNow: 'Join Now!',
  Download: 'Download',
  Credits: 'Credits',
  CreditLeft: 'Credit left',
  Contest: 'Contest',
  AlreadyTakenScreenName: 'This screen name is already taken, please try some other name',
  AllAnswerSelected: "All questions' answer must be selected except one skipped",
  NoQuestionSkipped: 'One question must be skipped',
  NoQuestionMarked2x: 'One question must be marked as 2x',
  Time: 'Time',
  SomethingWentWrong: 'Something went wrong!',
  ServiceTemporarilyUnavailable: 'Service Temporarily Unavailable',
  MyPredictions: 'My predictions',
  MyContests: 'My contests',
  MakeNewPrediction: 'Add prediction',
  JoinLeague: 'Join League',
  PleaseChoosePrediction: 'Please choose a prediction or create new prediction to join league',
  UpdatePicks: 'Update Prediction',
  UpcomingMatches: 'Upcoming Matches',
  WinnersDeclared: 'Winners Declared',
  ErrorMessage:
    'There maybe problem in loading data from server. Or check your internet and try again.',
  TryAgain: 'Try again',
  NoDataFound: 'Nothing to show',
  PleaseManageBalance: 'Please manage minimum balance to join league',
  CorrectAnswer: 'Correct Answer',
  YouHaveWon: 'You have won',
  Transfer: 'Transfer',
  NameMissing: 'Enter Name',
  FirstNameMissing: 'Enter First Name',
  LastNameMissing: 'Enter Last Name',
  ChooseState: 'Please select state',
  SelectGender: 'Please select gender',
  referralLinkCopied: 'Refer link copied!',
  PleaseVerifyAccount: 'Please verify your account first',
  CheckingVerificationStatus: 'Checking verification status....',
  AccNo: 'Acc No.',
  PendingForApproval: 'Pending for approval',
  VerificationRejected:
    'Your submitted details are rejected. Please provide correct detail by editing the below form',
  VerificationRejectedPan: 'Your Pan Card details are rejected. Please provide correct details',
  VerificationRejectedBank:
    'Your bank account details are rejected. Please provide correct details',
  AdminComment: 'Admin Comment: ',
  ReverifyDetails: 'Reverify details',
  PAN_DetailsSent: 'PAN details are sent successfully for verification',
  BankDetailsSent: 'Bank account details are sent successfully for verification',
  PleaseEnterAmount: 'Please enter amount first',
  EnterMinimumAmount: 'Please add minimum amount ₹50',
  PleaseUpdatePhoneNumber: 'Please update phone number',
  Applied: 'Applied',
  Apply: 'Apply',
  Yes: 'Yes',
  No: 'No',
  WalletBalance: 'Wallet Balance',
  TotalBuyIn: 'Total Buy-In',
  TransferableAmount: 'Transferable Amount*',
  TaxDeduction: 'Tax Deduction**',
  FirstRemark: '*Amount post tax deduction, if any.',
  SecondRemark: '**31.2% tax is deducted on winnings above ₹ 1000 as per Govt of India directive.',
  SureToCompleteTransfer: 'Are you sure you want to complete this transfer?',
  ComingSoon: 'Coming soon',
  NoMatchFound: 'No match found',
  NoContestFound: 'No contest found',
  NoAnswerFound: 'No answer found',
  JoinTelegram: 'Join Telegram',
  InvalidPANNumber: 'Invalid PAN number',
  PressBackAgain: 'Please click BACK again to exit!',
  Team: 'Team',
  AddTeam: 'Add Team',
  createNewTeam: 'Create New Team',
  JoinedWith: 'Joined With',
  YourWinnings: 'Your Winnings',
  YouWon: 'You Won',
  NoTeamFound: 'No Team Found',
  TeamAdded: 'Already 6 teams added.',
  NoPlayerFound: 'No Players Found',
  PricePool: 'Prize Pool',
  PRIZEPOOL: 'Prize Pool',
  SPOTS: 'Spots',
  WINNERS: 'Winners',
  ENTRY: 'Entry Fee',
  TeamsLeft: 'teams left',
  ContestJoined: 'Contest Joined',
  NotCancel: "This contest won't cancel even if they don't fill up",
  Join6Teams: 'In this multi-entry contest, join with up to 6 teams',
  Join11Teams: 'In this multi-entry contest, join with up to 11 teams',
  BonusCash: 'You can use bonus cash to join this league',
  MaxPlayers: 'Max 7 players from a team',
  MaxPlayersKabaddi: 'Max 5 players from a team',
  NoTeam: 'You have not created any team for this match yet.',
  CreateYourTeam: 'Create Your Team',
  TransactionFailed: 'Transaction Failed',
  TransactionSuccess: 'Transaction Success',
  TransactionCanceled: 'Transaction canceled',
  EnterYourPassword: 'Password',
  MobileVerfication: 'Mobile Verification',
  EnterOtpSentTo: 'Enter OTP sent to ',
  AccountInformation: 'Account Information',
  TermAndConditionMessage: 'By signing up, you agree to the ',
  TermAndCondition: 'Term & Conditions ',
  PrivacyPolicy: 'Privacy Policy  ',
  And: 'and ',
  VerifyYourAccountLabel: 'Verify your account to activate withdraw money service',
  IGamioWallet: 'IGamio Wallet',
  PlayWallet: 'Play Wallet',
  PokerWallet: 'Poker Wallet',
  Bonus: 'Bonus',
  VerifyAC: 'Verify Account',
  AddCashIGamioWallet: 'Add Cash (IGamio Wallet)',
  AddCashDesc: 'Using your netbanking, UPI, Debit Card and more',
  TransferMoney: 'Transfer Money',
  TransferMoneyDesc: 'Transfer your winnings from Play Wallet to iGamio Wallet.',
  TransferMoneyPokerDesc: 'Transfer your winnings from Poker Wallet to iGamio Wallet.',
  TransitionHistory: 'Transaction History',
  TransitionHistoryDesc: 'Know your transaction history',
  WithDrawMoney: 'Withdraw Money',
  WithDrawMoneyDesc: 'Verify Your Account First',
  WithDrawMoneyDescEnable: 'Withdraw Money in Your Account.',
  TDSHistoryDesc: 'Know your TDS History',
  CashfreeWebBackPress:
    'Please click on the top left back arrow icon, to proceed for canceling the payment',
  EnterDepositAmount: 'Enter Deposit Amount',
  ORSelectOneOfTheAnountsFromBelow: 'Or select one of the amounts from below',
  PleaseEnterPromoCode: 'Please enter promo code',
  EnterAmountToWithdrawMoney: 'Enter amount to withdraw money',
  EnterWithdrawAmount: 'Enter Withdraw Amount',
  MinimumWithdrawalAmount: 'Minimum withdrawal amount is Rs 200/-',
  MinimumDepositAmount: 'Minimum Deposit amount is Rs 50/-',
  PaytmTransfer: 'Paytm Transfer',
  BankTransfer: 'Bank Transfer',
  WithdrawMoneyValidation: 'Please enter minimum amount Rs 200/-',
  MyProfile: 'My Profile',
  PointsSystem: 'Points System',
  Faq: "FAQ's",
  OurCustomerAvailableLabel: 'Our Customer Support is Available 24*7',
  ReferAndEarn: 'Refer And Earn',
  RevenueAnalytics: 'Revenue Analytics',
  ReferralLinkLabel: 'Referral Link',
  ReferralLinkGeneratedMessage: 'Referral link is generated successfully',
  TapToCopyCode: 'Tap to copy paste',
  EmailVerification: 'Email Verification',
  SendEmail: 'Send Email',
  PanVerification: 'Pan Verification',
  MobileNumber: 'Mobile Number',
  Pan: 'PAN',
  BankAccount: 'Bank Account',
  Submitted: 'Submitted',
  EmailEnterOtpLabel: 'Please enter the verification code we sent to your email address',
  PhoneNumberEnterOtpLabel: 'Please enter the verification code we sent to your mobile number',
  ProfileVerification: 'Profile Verification',
  TotalMatchPlayed: 'Matches Played',
  TotalContestPlayed: 'Contests Played',
  TotalContestWon: 'Contests Won',
  TotalWinning: 'Winnings',
  Mobile: 'Mobile',
  Email: 'Email',
  PANCard: 'PAN Card',
  Bank: 'Bank',
  ProfileInfo: 'Profile Info',
  Age: 'Age',
  NA: 'NA',
  Cancel: 'Cancel',
  UpdateTeamName: 'Update Team Name',
  Upcoming: 'Upcoming',
  Completed: 'Ended',
  Live: 'Live',
  Reviewed: 'Reviewed',
  InProgress: 'In Progress',
  SetTeamName: 'Set Team Name',
  Information: 'Information',
  MatchDeadlinedFinished: 'Match Deadline Finished',
  Name: 'Name',
  PleaseEnterTeamName: 'Please Enter Team Name',
  PleaseEnterUsername: 'Please Enter Username',
  PleaseSelectAtLeastOnePlayerToSeePreview: 'Please select at least one player to see preview',
  LineupOut: 'Lineups Out',
  TEAMS: 'TEAMS',
  Playing: 'Playing',
  NotPlaying: 'Not Playing',
  FantasyPointSystem: 'Fantasy Point System',
  Legalities: 'Legalities',
  YouHaveInSufficientCredit: 'You have insufficient credit.',
  PleaseSelectOtherPlayers: 'Please select other players',
  sessionExpiredPleaseLoginAgain: 'Session Expired, Please login again',
  LoginSuccessMsg: 'User login successfully',
  RegisteredSuccessMsg: 'User Registered Successfully',
  view: 'View',
  ImageUploadSuccess: 'Image uploaded successfully',
  ImageUploadFailed: 'Image upload failed',
  PleaseUploadImageAgain: 'Please upload image again',
  Address: 'Address',
  Street: 'Street',
  MissingStreet: 'Enter Street',
  City: 'City',
  MissingCity: 'Enter City',
  Zip: 'PINCode',
  AddAddress: 'Add Address',
  UpdateAddress: 'Update Address',
  SetDefault: 'Set Default',
  AddressAdded: 'Address added successfully',
  AddressUpdated: 'Address updated successfully',
  AddressToggled: 'Default changed successfully',
  profileUpdatedSuccessfully: 'Profile Updated Successfully',
  userNameUpdatedSuccessfully: 'User name Updated Successfully',
  youAlreadyAddedUserName: 'You already added user name',
  thisUserNameIsAlreadyTaken: 'This username is already taken',
  userNameTypoError: 'Only letters and numbers are allowed. No spaces.',
  AddressDeleted: 'Address Deleted Successfully',
  setDefault: 'Set as default',
  Default: 'Default',
  MissingZipCode: 'Enter PINCode',
  InvalidZipCode: 'Invalid PINCode',
  Status: 'Status',
  A_CNo: 'A/C No',
  DeletedSuccessfully: 'Deleted Successfully',
  ContestJoinedSuccessfully: 'Contest joined successfully, Best Of Luck!',
  switchTeam: 'Switch Team',
  createTeam: 'Create Team',
  joinContest: 'Join Contest',
  teamSwitchedSuccessfully: 'Team Switched Successfully',
  teamSwitchedErrorMessage: 'You cannot switch to a team you have already added',
  leagueJoined: 'League Joined Successfully',
  teamCreateSuccessfully: 'Team Created Successfully',
  teamUpdatedSuccessfully: 'Team Updated Successfully',
  contestAlreadyFilledMsg: 'Contest Already Filled',
  matchLiveMsg: 'Match lived, you can not join now',
  matchCompletedMsg: 'Match completed, you can not join now',
  matchCancelMsg: 'Match cancelled, you can not join now',
  loginWithMobile: 'Login with Mobile',
  welcomeBackToIGamio: 'Welcome Back to iGamio',
  welcomeToIGamio: 'Welcome to iGamio',
  registerWithMobile: 'Register with Mobile',
  shareVia: 'Share via',
  clickToCopy: 'Click to copy',
  linkCopied: 'Link successfully copied',
  loginWithEmail: 'Login with Email and password',
  transferMoneyPokerToIgamio: 'Transfer Money Poker to Igamio Wallet',
  otp: 'OTP',
  matchSquadNotOutYet: 'Match Squad not out yet',
  pleaseSetState: 'Please set state to continue',
  close: 'Close',
  stateSetSuccessfully: 'State set successfully',
  alreadyJoinedWithThisTeam: 'Already joined with this team',
  matchDeadlineFinishedSorryYouCannotJoinNow: 'Match deadline finished, sorry you can not join now',
  inSufficientAmountInYourWallet: 'You have insufficient amount in your wallet',
  moneyTransferredSuccessfully: 'Money transferred successfully',
  maxTeamMsg: 'You can add only 11 teams.',
  withdrawRequestSentSuccessfully: 'Withdraw request sent successfully',
  msgForPreviewTeamBeforeDeadline: 'Please wait till the match starts to view other teams',
  msgForPreviewTeamBeforeDeadlineYN: 'Please wait till the match starts to view other answers',
  PaymentPendingMsg: 'Transaction failed due to payment pending',
  LoginSignupTermAndCondition:
    'By logging in or signing up, you agree to the following:\n1. You are above 18 years of age. \n2. You are not a resident of Indian states of Andhra Pradesh, Assam, Odisha, Telangana, Nagaland, Meghalaya & Sikkim.',
  PleaseDownloadApplicationToUseThisFeature: 'Please download application to use this feature.',
  both: 'Both',
  filterByTeams: 'Filter By Teams',
  Settings: 'Settings',
  NoEntryAllowed: ' allowed in this contest',
  AppSettings: 'App Settings',
  Notifications: 'Notifications',
  AllNotifications: 'All Notifications',
  SmartNotifications: 'Smart Notifications',
  PlayerInfo: 'Player Information',
  PlayerPointWillUpdateAfterMatch: 'Player points will be updated only after the match starts',
  pdfGeneratedSuccessfully: 'Pdf generated Successfully',
  pdfGeneratedError: 'Please try again, something went wrong',
  playerInfo: 'Player Information',
  NoContestJoined: 'You have not joined any contest for this match yet.',
  JoinYourContest: 'Join Your Contest',
  InWinningZone: 'In Winning Zone',
  FirstPrize: 'First Prize = ',
  NoMyMatchJoined: 'You have not joined any match.',
  ViewUpcomingMatch: 'View Upcoming Match',
  pleaseProvideStoragePermission: 'Please provide storage permission to download pdf',
  allFilter: 'All Filters',
  contestSize: 'Contest Size',
  sortBy: 'Sort By',
  clear: 'Clear',
  viewMore: 'View All',
  addEmail: 'Add Email',
  emailAddedSuccessfully: 'Email Added Successfully',
  verificationCode: 'verification code',
  restart: 'Restart',
  cannotUpdateDOB: 'can not update DOB after pan card verified',
  playerAreNotPlayingMsg: 'player(s) not playing.',
  subsAdded: 'substitute(s) added',
  gadgetLeague: 'Gadget League',
  giveAwayLeague: 'Giveaway League',
  serverDownMessage:
    'We are down for maintenance. All the winnings and refunds are safe, and will be processed as soon as we are up.',
  TotalWinnings: 'Total Winnings',
  InternetMessage:
    'Please make sure you are connected with internet or our servers are not responding.',
  alreadyRegisteredWithPhoneNumber: 'Already registered with this phone number',
  notRegisteredMsg: 'This phone number is not registered with us',
  emailSpamMessage:
    'Please check your spam folder, if you do not find verification email in your inbox.',
  signInWithEmail: 'Sign in with Email',
  bankOptionalMessage:
    '*Note : Not required for KYC, only required for bank withdrawals. Bank Verification is not necessary for paytm withdrawals.',
  SetResetPassword: 'Set/Reset Password',
  PleaseVerifyEmailToResetPassword: 'Please verify email to reset password',
  PleaseVerifyEmailToAddPassword: 'Please verify email to add password',
  totalEarnings: 'Total Earnings',
  PleaseDownloadMobileApp: 'Please download mobile app to verify your account',
  gadgetLeagueMessage:
    'iGamio is not associated with any of the brands mentioned above in the winnings breakup.\n',
  substituteAddedSuccessfully: 'Substitute added successfully',
  restrictionMessage: 'Sorry, this game is not playable in your location.',
  fantasySubstituteRule:
    '• Make your team on iGamio.\n• Substitute 3 non performers before second innings begin.\n• You can replace either Captain or Vice Captain with one player.\n• Once a player is substituted he can’t be a part of your team again.\n• Substitute players according to team formation and credit points.\n• The points earned by your original player in first innings and points earned by substituted player in second will be added.\n• Substitute upto 3 non performing players before the second innings begin.',
  pokerForcedLogout: 'Poker is accessed at other device or platform!',
  internetOnMessage: 'Please turn on internet to access application',
  offerPage: 'Offer',
  emailLimitMsg: 'Daily verification request limit reached! Please try again after 24 hours.',
  rateLimitMsg:
    'We are getting unusual amount of requests from current IP. Please change network or try again in an hour.'
};
